import { FuseNavigationItem } from '../navigation.types';

export const marketingNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard.divider',
        type: 'divider',
    },
    {
        id: 'dashboards',
        title: 'Dashboards',
        tooltip: 'Dashboard',
        tooltipKey: 'DASHBOARD',
        subtitle: 'Unique dashboard designs',
        type: 'basic',
        icon: 'heroicons_outline:dashboard',
        link: '/dashboard',
    },
    {
        id: 'campaign',
        title: 'Campaign',
        tooltip: 'Campaign',
        tooltipKey: 'CAMPAIGN',
        subtitle: 'campaign',
        type: 'basic',
        icon: 'announced',
        link: '/campaign/all',
    },
    {
        id: 'campaign_builder',
        title: 'Campaign Builder',
        tooltip: 'Campaign Builder',
        tooltipKey: 'CAMPAIGN_BUILDER',
        subtitle: 'campaign Builder',
        type: 'basic',
        classes: {icon: 'bx  bx-git-repo-forked bx-rotate-180 text-[22px]'},
        link: '/campaign-builder',
        hasPermission: false,
        isVisible: false,
    },
    {
        id: 'prospect_managemet',
        title: 'Prospect Management',
        subtitle: 'Prospect Management subtitle',
        tooltip: 'Prospect Management',
        tooltipKey: 'PROSPECT_MANAGEMENT',
        type: 'basic',
        icon: 'prospect',
        link: '/prospect-management',
    },
    {
        id: 'prospect_filter',
        title: 'Prospect Finder',
        subtitle: 'Prospect Finder subtitle',
        tooltip: 'Prospect Finder',
        tooltipKey: 'PROSPECT_FINDER',
        type: 'basic',
        classes:{icon:'ri-user-search-line text-2xl'},
        link: '/prospect-finder',
        hasPermission: false,
        isVisible: false,
    },
    {
        id: 'campaign.inboxes',
        title: 'Unified Inbox',
        subtitle: 'Unified Inbox subtitle',
        tooltip: 'Unified Inbox',
        tooltipKey: 'UNIFIED_INBOX',
        type: 'basic',
        icon: 'inbox',
        link: '/unified-inbox',
    },
    {
        id: 'email_accounts',
        title: 'Email Accounts',
        subtitle: 'Email Accounts subtitle',
        tooltip: 'Email Accounts',
        tooltipKey: 'EMAIL_ACCOUNTS',
        type: 'basic',
        classes: { icon: 'ri-at-line font-normal' },
        link: '/email-accounts',
    },
    {
        id: 'email_warm_up',
        title: 'Warmify',
        subtitle: 'Warmify subtitle',
        tooltip: 'Warmify',
        tooltipKey: 'WARMIFY',
        type: 'basic',
        classes:{icon:'ri-fire-line'},
        link: '/warmify',
    },
    {
        id: 'marketing_email_template',
        title: 'Templates',
        subtitle: 'Templates subtitle',
        tooltip: 'Templates',
        tooltipKey: 'TEMPLATES',
        type: 'basic',
        icon: 'templates',
        link: '/templates',
    }
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        tooltip: 'Dashboards',
        type: 'aside',
        icon: 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'Apps',
        tooltip: 'Apps',
        type: 'aside',
        icon: 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'pages',
        title: 'Pages',
        tooltip: 'Pages',
        type: 'aside',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'UI',
        tooltip: 'UI',
        type: 'aside',
        icon: 'heroicons_outline:collection',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Navigation',
        tooltip: 'Navigation',
        type: 'aside',
        icon: 'heroicons_outline:menu',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'DASHBOARDS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'APPS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'others',
        title: 'OTHERS',
        type: 'group',
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'aside',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'User Interface',
        type: 'aside',
        icon: 'heroicons_outline:collection',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Navigation Features',
        type: 'aside',
        icon: 'heroicons_outline:menu',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'Apps',
        type: 'group',
        icon: 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'group',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'UI',
        type: 'group',
        icon: 'heroicons_outline:collection',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Misc',
        type: 'group',
        icon: 'heroicons_outline:menu',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
